import { useEffect } from "react";
import Firmware from "Components/Dashboard/Components/charts/Firmware";
import FlowNumber from "Components/Dashboard/Components/charts/FlowNumber";
import Health from "Components/Dashboard/Components/charts/Health";
import Map from "Components/Dashboard/Components/charts/Map";
import Model from "Components/Dashboard/Components/charts/Model";
import Strength from "Components/Dashboard/Components/charts/Strength";
import { Row, Col } from "antd";
import { useAppDispatch, useAppSelector } from "store/hook";
import { setIsMapOnly } from "../dashboardSlice";
// 定義一個組件列表，包括組件和對應的值
const componentsList = [
  { component: <Firmware />, value: "firmware", key: "firmwareKey" },
  { component: <FlowNumber />, value: "IoT" },
  { component: <Health />, value: "health" },
  { component: <Model />, value: "model" },
  { component: <Strength />, value: "strength" },
  { component: <Map />, value: "map" },
];

const ChartList = () => {
  // dashboardSetting 儀表盤顯示設定
  const { dashboardSetting } = useAppSelector((state) => state.dashboard);
  const disp = useAppDispatch();

  useEffect(() => {
    // 創建一個空陣列來存儲已選中的設置
    const dashboardSetting_checked: any = [];
    // 遍歷 dashboardSetting 物件，找出值為 true 的設置，並將它們添加到 dashboardSetting_checked 中
    Object.entries(dashboardSetting).forEach(([key, value]) => {
      if (value === true) dashboardSetting_checked.push([key, value]);
    });
    // 如果只有一個已選中的設置且該設置是 "map"，則設定為僅顯示地圖
    // dashboardSetting_checked e.g.: [['model', true], ['map', true]]
    if (dashboardSetting_checked.length === 1 && dashboardSetting_checked[0][0] === "map") {
      disp(setIsMapOnly(true));
    } else {
      disp(setIsMapOnly(false)); // 否則取消僅顯示地圖設定
    }
  }, [dashboardSetting]);

  return (
    <Row gutter={24} style={{ margin: "0px" }}>
      {/* 過濾出已選中的 dashboardSetting 選項，並將它們渲染為對應的組件 */}
      {Object.entries(dashboardSetting)
        .filter(([key, value]) => value)
        .map(([param]) => {
          return (
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={param === "map" ? 24 : 12}
              xl={param === "map" ? 24 : 12}
              xxl={param === "map" ? 24 : 6}
              key={param}
              style={{ padding: "0" }}
            >
              {/* 根據 param 值找到對應的組件，並渲染 */}
              {componentsList.find((item) => item.value === param)?.component}
            </Col>
          );
        })}
    </Row>
  );
};

export default ChartList;
